import React from "react";
import "./Header.css";
import Amazon from "../Images/pngimg.com - amazon_PNG11.png";
import SearchIcon from "@mui/icons-material/Search";
import PlaceOutlinedIcon from "@mui/icons-material/PlaceOutlined";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import { Link } from "react-router-dom";
import { useStateValue } from "../StateProvider/StateProvider";
import { auth } from "../../firebase";
import usFlag from "../Header/download.png";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

function Header() {
  const [{ basket, user }, dispatch] = useStateValue();
  const handleAuthenticaton = () => {
    if (user) {
      auth.signOut();
    }
  };

  return (
    <div className="header">
      <Link className="hover" to="/">
        <img className="header__logo" src={Amazon} alt="logo" />
      </Link>
      <div className="header__option">
        <div className="header__optionLineOne more__right">Hello</div>
        <div className="fix">
          <div>
            <PlaceOutlinedIcon className="header__addres" />
          </div>

          <div className="header__optionLineTwo">Select your address</div>
        </div>
      </div>
      {/* second start */}
      <div className="searching__item">
        <div>
          <select className="style_item">
            <option value="">All</option>
            <option value="">Alexa</option>
            <option value="">Devices</option>
            <option value="">Fresh</option>
            <option value="">Warehouse</option>
          </select>
        </div>
      </div>
      <div className="header__search">
        <input className="header__searchIput" type="text" />
        <SearchIcon className="header__searchIcon" />
      </div>
      {/* third start */}
      <div className="header__nav">
        {/*  */}
        <div className="header__option header__warp us ftr_wrapper">
          <img src={usFlag} alt="us-flage" /> <span>EN</span>
          <ArrowDropDownIcon className="arrow" />
        </div>
        {/*  */}

        <div className="header__option">
          <Link to={!user && "/login"} className="header__clearlink">
            <div className="header__optionLineOne color_white">
              Hello {!user ? "Guest" : user.email}
            </div>
            <div
              onClick={handleAuthenticaton}
              className="header__optionLineTwo sign"
            >
              {user ? "Sign out" : "sign In"}
            </div>
          </Link>
        </div>
        <Link to="orders" className="header__clearlink">
          <div className="header__option hover">
            <div className="header__optionLineOne small__right ">Returns</div>
            <div className="header__optionLineTwo">& Orders</div>
          </div>
        </Link>
      </div>
      <Link className="hover header__clearlink" to="/checkout">
        <div className="header__cart">
          <div className="cart__header">
            <AddShoppingCartIcon />
          </div>
          <div className="cart__item">{basket.length}</div>
          <div className="header__carttext">Cart</div>
        </div>
      </Link>
    </div>
  );
}

export default Header;
